import { FC } from 'react';

import * as Colors from '../../theme/colors';

type HighProps = {
  width?: string;
  color?: string;
};

export const High: FC<HighProps> = ({ width, color }) => (
  <svg
    role="img"
    width={width ?? '24'}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.80425 19L12 5.8868L20.1958 19H3.80425Z"
      stroke={color ?? Colors.high.primary}
      strokeWidth="2"
    />
  </svg>
);
